import { useEffect, useState } from 'react';
// Round flag for a country (code = two-letter country code, e.g. "PL").
// The flag set is a separate file that is loaded only when a flag is first needed, so it never slows down other pages.
let flagModule = null;
let flagPromise = null;
const loadFlags = () => {
  if (flagModule) return Promise.resolve(flagModule);
  if (!flagPromise) {
    flagPromise = import('@/components/solutions/solutionFlags').then((m) => {
      flagModule = m;
      return m;
    });
  }
  return flagPromise;
};
const SolutionFlag = ({ code, name = '', className = 'h-10 w-10' }) => {
  const [src, setSrc] = useState(() => (flagModule ? flagModule.flagSrc(code) : null));
  useEffect(() => {
    let alive = true;
    loadFlags()
      .then((m) => {
        if (alive) setSrc(m.flagSrc(code));
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [code]);
  if (!src) return <span className={`${className} rounded-full bg-slate-100 ring-1 ring-slate-200 shrink-0 inline-block`} aria-hidden="true" />;
  return (
    <img
      src={src}
      alt={name ? `Flag of ${name}` : ''}
      className={`${className} rounded-full ring-1 ring-slate-200 shadow-sm shrink-0`}
      loading="lazy"
      draggable={false}
    />
  );
};
export default SolutionFlag;
